import React from 'react';
import DeleteConfirmModal from '../../../../../components/common/DeleteConfirmModal';

const DeleteExamModal = ({ isOpen, onClose, onDelete, examTitle }) => {
  return (
    <DeleteConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onDelete}
      itemType="الاختبار"
      itemTitle={examTitle}
    />
  );
};

export default DeleteExamModal;
